export let checkTime = (str) => {
    let time = "";
    if (str.includes(":")) {
        time = str.replace(":", "");
    } else {
        time = str;
    }

    let nTime = time.length;
    if (nTime < 5) {
        time = time.split("");

        let hours = "",
            minutes = "";
        if (nTime === 4) {
            hours = time[0] + "" + time[1];
            minutes = time[2] + "" + time[3];
        } else if (nTime === 3) {
            hours = "0" + time[0];
            minutes = time[1] + "" + time[2];
        } else if (nTime === 2) {
            hours = time[0] + "" + time[1];
            minutes = "00";
        } else if (nTime === 1 && time[0] !== "?") {
            hours = "0" + time[0];
            minutes = "00";
        }

        if (
            parseInt(hours) >= 0 &&
            parseInt(hours) < 24 &&
            parseInt(minutes) >= 0 &&
            parseInt(minutes) < 60
        ) {
            return hours + ":" + minutes;
        } else {
            return false;
        }
    }
    return false;
}

export let checkDate = (date) => {
    if (date.includes("-")) {
        let diaMesAño = date.split("-");
        let nums = diaMesAño.every((e) => {
            return !isNaN(e);
        });

        if (
            diaMesAño.length !== 3 ||
            nums ||
            parseInt(diaMesAño[0]) < 1 ||
            parseInt(diaMesAño[0]) > 31 ||
            parseInt(diaMesAño[1]) < 1 ||
            parseInt(diaMesAño[1]) > 12 ||
            parseInt(diaMesAño[2]) < 2010 ||
            parseInt(diaMesAño[2]) > 2300
        ) {
            return false;
        } else {
            return true;
        }
    } else if (date.includes("/")) {
        let diaMesAño = date.split("/");
        let nums = diaMesAño.every((e) => {
            return !isNaN(e);
        });

        if (
            diaMesAño.length !== 3 ||
            nums ||
            parseInt(diaMesAño[0]) < 1 ||
            parseInt(diaMesAño[0]) > 31 ||
            parseInt(diaMesAño[1]) < 1 ||
            parseInt(diaMesAño[1]) > 12 ||
            parseInt(diaMesAño[2]) < 2010 ||
            parseInt(diaMesAño[2]) > 2300
        ) {
            return false;
        } else {
            return true;
        }
    } else if (
        date === "yesterday" ||
        date === "ayer" ||
        (!isNaN(date) && parseInt(date) > 0 && parseInt(date) < 31)
    ) {
        return true;
    } else {
        return false;
    }
}

export let formatTime = (timeString) => {
    if (timeString.includes(" ")) {
        let parts = timeString.split(" ");

        let time = checkTime(parts[0]);
        if (time !== false) {
            let validateDate = checkDate(parts[1]);
            let fecha = "";
            if (validateDate) {
                fecha = parts[1];
            } else {
                fecha = "ayer";
            }
            return time + " " + fecha;
        } else {
            return "?";
        }
    } else {
        let time = checkTime(timeString);
        if (time !== false) {
            return time;
        } else {
            return "?";
        }
    }
}

export let longMsToTime = (s) => {
    let date = new Date(parseInt(s));
    let hours = date.getHours();
    let minutes = date.getMinutes();

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return hours + ":" + minutes;
}

export let msToTime = (s) => {
    
    let ms = s % 1000;
    s = (s - ms) / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    let mins = s % 60;
    let hrs = (s - mins) / 60;
    
    return pad(hrs) + ':' + pad(mins);
}

export let timeToMs = (strg) => {
    
    let strgParts = strg.split(":");

    let hours = parseInt(strgParts[0]);
    let minutes = parseInt(strgParts[1]);

    let ms = ( (hours * 3600) + (minutes * 60) ) * 1000;
    
    return ms;
}

/**
 * Obtiene por parametro 2 objetos de MomentJS, fecha inicio y fecha fin.
 * 
 * Devuelve el numero de días no laborales, incluyendo festivos. <-- TODO
 */
export const countNonWorkingDays = (start, end, hollydays) => {
    let days = 0;

    for (let i = moment(start); i.isSameOrBefore(end, "day"); i.add(1, 'days')) {
        if (i.isoWeekday() === 6 || i.isoWeekday() === 7) {
            days++;
        } else {
            hollydays.forEach((e) => {
                if (e.date.isSame(i, 'day')) {
                    days++;
                } 
            });
        }
    }
    return days;   
}


function pad(n, z) {
    z = z || 2;
    return ('00' + n).slice(-z);
}

export let getDateSring = () => {
    let today = (new Date()).toDateString();
    let todayParts = today.split(" ");
    let todayName = getDayName(todayParts[0]);
    let todayNumb = getDayNumb(todayParts[2]);

    return todayParts[1] + " " + todayNumb + ", " + todayName;
}

function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}

function getDayName(day) {
    switch (day) {
        case "Mon":
            return "Monday";
        case "Tue":
            return "Tuesday";
        case "Wed":
            return "Wednesday";
        case "Thu":
            return "Thusday";
        case "Fri":
            return "Friday";
        case "Sat":
            return "Saturday";
        case "Sun":
            return "Sunday";
    }
}

function getDayNumb(numb) {
    let nParts = numb.split("");
    let res = parseInt(numb).toString();
    switch (nParts[nParts.length-1]) {
        case "1":
            return res += "st";
        case "2":
            return res += "nd";
        case "3":
            return res += "rd";
        default:
            return res += "th";
    }
}